const getters = {
  listPictureslength(state) {
    return state.listPictures.length;
  },

  listPicturesCheckedlength(state) {
    return (
      state.listPictures.filter((picture) => picture.checked === true).length ||
      0
    );
  },
};

export default getters;
